function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.032 2.394l.07.058L7 6.35l3.9-3.898a.5.5 0 01.764.638l-.057.069-3.9 3.898 3.9 3.9a.5.5 0 01-.638.765l-.07-.058-3.9-3.9-3.898 3.9a.5.5 0 01-.765-.638l.058-.069 3.899-3.9L2.394 3.16a.5.5 0 01.638-.765z",
  fill: "#D24667",
  fillRule: "nonzero"
})));